// @flow
import React, {useEffect, useState} from "react";
import {useHistory, Link} from "react-router-dom";
import {useObserver} from "mobx-react-lite";
import {
    Col,
    Skeleton,
    Row,
    Table,
    Descriptions,
    Tag,
    Select,
    Empty,
    Upload,
    message,
    Space,
    Form,
    Modal,
    DatePicker,
    Input
} from "antd";
import {useOptions} from "../../../../../hooks/useOptions";
import {useFormik} from "formik";
import * as yup from "yup";
import {useTranslation} from "react-i18next";
import moment from "moment";
import {useStore} from "../../../../../hooks/useStore";
import {arrayAlphabeticalSort} from "../../../../../utils/helpers";
export const ChangeSubcompanyStatusModal = ({
    visibility,
    subCompany,
    onClose = () => {},
    recall = () => {}
}) => {
    const stores = useStore();
    const {t} = useTranslation([
        "companyDetail",
        "courierTypes",
        "companyUserSelect",
        "newCompany"
    ]);
    const {optionLoading, options, findInOptions} = useOptions({
        groupName: "subCompanyInactivation"
    });

    const requiredMessage = t("validation.required", {ns: "common"});
    const formik = useFormik({
        initialValues: {
            lostMonth: undefined,
            lostDate: undefined,
            lostSubject: undefined,
            lostedBy: undefined
        },
        enableReinitialize: true,
        validateOnChange: true,
        validationSchema: yup.object().shape({
            lostMonth: yup.string().when([], {
                is: () => !Boolean(subCompany?.disabled),
                then: yup.string().required(requiredMessage),
                otherwise: yup.string()
            }),
            lostDate: yup.string().when([], {
                is: () => !Boolean(subCompany?.disabled),
                then: yup.string().required(requiredMessage),
                otherwise: yup.string()
            }),
            lostSubject: yup.string().when([], {
                is: () => !Boolean(subCompany?.disabled),
                then: yup.string().required(requiredMessage),
                otherwise: yup.string()
            }),
            lostedBy: yup.string().when([], {
                is: () => !Boolean(subCompany?.disabled),
                then: yup.string().required(requiredMessage),
                otherwise: yup.string()
            })
        }),
        onSubmit: async values => {
            try {
                const payload = {
                    ...subCompany,
                    disabled: !subCompany.disabled
                };

                if (!subCompany?.disabled) {
                    const lostDetails = {
                        lostDate: values?.lostDate,
                        lostMonth: values?.lostMonth,
                        lostSubject: values?.lostSubject,
                        lostedBy: values?.lostedBy
                    };
                    payload.lostDetails = {...lostDetails};
                }
                const updatedCompany = await stores.companyStore.updateSubCompanyStatus({
                    subCompany: payload
                });
                if (updatedCompany) {
                    message.success("Alt firma durumu başarıyla güncellendi.");
                    onClose();
                    recall();
                }
            } catch (e) {
                console.log(e);
            }
        }
    });

    const {
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        isSubmitting,
        resetForm,
        setFieldValue
    } = formik;

    return (
        <Modal
            visible={visibility}
            centered
            okText={t("actions.update", {ns: "common"})}
            onOk={handleSubmit}
            cancelText={t("modal.cancelButton2", {ns: "common"})}
            data-testid="courierResetPasswordUpdateModal"
            okButtonProps={{loading: isSubmitting}}
            onCancel={() => {
                resetForm();
                onClose();
            }}
        >
            <>
                <h3 style={{display: "flex", alignItems: "center"}}>
                    {subCompany?.name}
                    <Tag
                        color={Boolean(subCompany?.disabled) ? "red" : "green"}
                        style={{marginLeft: "10px"}}
                    >
                        {Boolean(subCompany?.disabled)
                            ? t("other.inactive", {ns: "common"})
                            : t("other.active", {ns: "common"})}
                    </Tag>
                </h3>
                {t("companyDetail.modal.subcompanyUpdateStatus.content", {
                    ns: "companyDetail",
                    disabledStatus: Boolean(subCompany?.disabled)
                        ? t("other.activeLowercase", {ns: "common"})
                        : t("other.inactiveLowercase", {ns: "common"})
                })}
            </>
            {!Boolean(subCompany?.disabled) ? (
                <Form
                    autoComplete="off"
                    labelCol={{span: 24}}
                    wrapperCol={{span: 24}}
                    layout="vertical"
                >
                    <Form.Item
                        label="Kayıp Tarihi"
                        style={{marginTop: "20px"}}
                        validateStatus={errors.lostDate && touched.lostDate ? "error" : "success"}
                        help={errors.lostDate && touched.lostDate ? errors.lostDate : null}
                    >
                        <DatePicker
                            placeholder="31.12.2024"
                            style={{width: "100%"}}
                            format="DD.MM.YYYY"
                            onChange={date => {
                                setFieldValue("lostDate", date);
                                if (date) {
                                    setFieldValue("lostMonth", moment(date).month() + 1);
                                }
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Kayıp Ayı"
                        validateStatus={errors.lostMonth && touched.lostMonth ? "error" : "success"}
                        help={errors.lostMonth && touched.lostMonth ? errors.lostMonth : null}
                    >
                        <Select
                            placeholder="Aralık"
                            style={{width: "100%"}}
                            value={values?.lostMonth}
                            onChange={e => setFieldValue("lostMonth", e)}
                        >
                            {Array.from({length: 12}, (_, i) => (
                                <Select.Option key={i + 1} value={i + 1}>
                                    {moment()
                                        .month(i)
                                        .format("MMMM")}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Kayıp Nedeni"
                        validateStatus={
                            errors.lostSubject && touched.lostSubject ? "error" : "success"
                        }
                        help={errors.lostSubject && touched.lostSubject ? errors.lostSubject : null}
                    >
                        <Select
                            loading={optionLoading}
                            disabled={optionLoading}
                            style={{width: "100%"}}
                            value={values?.lostSubject}
                            onChange={e => setFieldValue("lostSubject", e)}
                            placeholder="Düzensiz Ödeme"
                        >
                            {Array.isArray(options?.lostReason) &&
                                arrayAlphabeticalSort(options.lostReason, "name").map(item => (
                                    <Select.Option key={item?.key} value={item?.value}>
                                        {findInOptions({
                                            group: "lostReason",
                                            value: item?.value
                                        })}
                                    </Select.Option>
                                ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Kime Kaybedildi"
                        validateStatus={errors.lostedBy && touched.lostedBy ? "error" : "success"}
                        help={errors.lostedBy && touched.lostedBy ? errors.lostedBy : null}
                    >
                        <Input
                            placeholder="Kime Kaybedildi"
                            value={values?.lostedBy}
                            onChange={handleChange}
                            name="lostedBy"
                        />
                    </Form.Item>
                </Form>
            ) : (
                <></>
            )}
        </Modal>
    );
};
